import React from 'react';
import { Reveal } from './Reveal';
const stats = [['12', 'Tomos completos'], ['+300', 'Actividades listas'], ['+80', 'Horas ahorradas por mes'], ['100%', 'Lo recomiendan']];
export function StatsBar() {
  return <section className="border-y border-brand-line bg-brand-alt py-10 sm:py-12" data-id="element-153" data-mp="1oa3tvqz0zfs9">
      <Reveal className="mx-auto grid max-w-5xl grid-cols-2 gap-y-9 px-4 text-center md:grid-cols-4 md:gap-8" data-id="element-154" data-mp="1jd3rpr5aqx6f">
        {stats.map(([value, label], index) => <div key={label} className={`flex flex-col items-center justify-center px-2 ${index > 0 ? 'md:border-l md:border-brand-line' : ''}`} data-id="element-155" data-mp="19miti4tjbuo1" data-mpi={index}>
            <span className="font-display text-[2rem] font-semibold leading-none text-brand-terra sm:text-[2.5rem]" data-id="element-156" data-mp="10m2rz0wcqxlt">
              {value}
            </span>
            <span className="mt-2.5 text-[10px] font-semibold uppercase tracking-[0.14em] text-brand-gray sm:text-[11px]" data-id="element-157" data-mp="vm7xknddbpw0">
              {label}
            </span>
          </div>)}
      </Reveal>
    </section>;
}